var projectTimeline = {
	"Project timeline": "Linea temporale del progetto",
	"None planned": "Nessun progetto pianificato",
	"1-3 months": "1-3 mesi",
	"4-6 months": "4-6 mesi",
	"7-12 months": "7-12 mesi",
	"More than 1 year": "Più di un anno"
};

export { projectTimeline as default };
